import { NewsIndexClient } from 'hb-react/frontoffice/apps/NewsIndex/startup/NewsIndexClient';
import { type Config } from 'hb-react/frontoffice/apps/NewsIndex/types';

interface NewsAppClientProps {
  config: Config;
}

const NewsAppClient = ({ config }: NewsAppClientProps) => (
  <NewsIndexClient config={config} />
);

export default NewsAppClient;
